module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-lg-8"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" " + _vm._s(_vm.search_result))]), _vm._v(" in Abuja")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.search_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.search_message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cards-row"
  }, [_vm._l((_vm.businesses), function(business) {
    return [_c('div', {
      staticClass: "card-row"
    }, [_c('a', {
      staticStyle: {
        "color": "inherit"
      },
      attrs: {
        "href": 'business?context=' + business.business_url_name
      }
    }, [_c('div', {
      staticClass: "card-row-inner"
    }, [_c('div', {
      staticClass: "card-row-image"
    }, [_c('img', {
      staticClass: "full-image img-responsive",
      attrs: {
        "src": _vm.img_url + business.business_image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-row-label"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent(business)
        }
      }
    }, [_vm._v(_vm._s(business.business_category_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row-body"
    }, [_c('h2', {
      staticClass: "card-row-title"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent(business)
        }
      }
    }, [_vm._v(_vm._s(business.business_name))])]), _vm._v(" "), _c('div', {
      staticClass: "card-row-content"
    }, [_c('p', [_vm._v("\r\n                                                        " + _vm._s(business.business_category_name) + "\r\n                                                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row-properties points"
    }, [_c('dl', [_c('dd', [_vm._v("Review(s)")]), _c('dt', [_vm._v(_vm._s(business.business_reviews_total_count))]), _vm._v(" "), _c('dd', [_vm._v("Category")]), _c('dt', [_vm._v(_vm._s(business.business_category_name))]), _vm._v(" "), _c('dd', [_vm._v("Location")]), _c('dt', [_vm._v(_vm._s(business.business_address))]), _vm._v(" "), _c('div', {
      staticClass: "points"
    }, [_c('dd', [_vm._v("Rating")]), _c('dt', [_vm._v(_vm._s(business.business_rating_average_rate) + " "), _c('i', {
      staticClass: "fa fa-star"
    })])])])])])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.businesses.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count)
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getSearchBusinesses(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])])]), _vm._v(" "), _c('sidebar')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-099b1132"}!./src/components/BusinessSearch/template.html
// module id = 268
// module chunks = 0